export const MOBILE_BLOCKER_OFF_COOKIE = 'mobileBlockerOff';
export const BLOCKER_OFF_COOKIE_EXPIRATION_DAYS = 30;
